// extracted by mini-css-extract-plugin
module.exports = {"Instructions":"styles_Instructions__18whK","howToLink":"styles_howToLink__38tO1","advanced":"styles_advanced__1ZlpH","note":"styles_note__2v4bB"};